<template>
  <div class="order-page">
    <el-card class="box-card">
      <!-- el-form -->
      <el-form :data="form"
               label-width="100px"
               style="width: 100%">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item prop="platCode"
                          label="行业">
              <el-select clearable
                         v-model="form.profession"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in platlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="business"
                          label="商家">
              <el-select v-loading="ptnListLoading"
                         clearable
                         v-model="form.business"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in ptnlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="store"
                          label="店铺">
              <el-select v-loading="shopListLoading"
                         clearable
                         v-model="form.store"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in shoplists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label-width
                          prop="buyer_nick"
                          label="客户昵称">
              <el-input v-model="form.buyer_nick"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="level"
                          label="等级">
              <number-range v-model="form.level" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="from"
                          label="来源">
              <el-input v-model="form.from"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label-width
                          prop="create_time"
                          label="日期">
              <el-date-picker v-model="form.create_time"
                              type="datetimerange"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"
                              value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card class="button-box">
      <action-line @action-line="handleActionLine"
                   :list="Desc.actionLine">
        <!-- <el-button @click="searchAreaStatus = !searchAreaStatus">{{ searchAreaStatus ? "收起" : "展开" }}</el-button> -->
      </action-line>
    </el-card>

    <!-- el-table -->
    <el-table v-loading="loading"
              height="calc(100vh - 100px)"
              border
              :data="tableData"
              style="width: 100%">
      <el-table-column prop="create_time"
                       align="center"
                       header-align="center"
                       label="日期"></el-table-column>
      <el-table-column prop="buyer_nick"
                       align="center"
                       header-align="center"
                       label="客户昵称"></el-table-column>
      <el-table-column prop="level"
                       align="center"
                       header-align="center"
                       label="等级"></el-table-column>
      <el-table-column prop="from"
                       align="center"
                       header-align="center"
                       label="来源"></el-table-column>
      <el-table-column prop="gender"
                       align="center"
                       header-align="center"
                       label="您的性别"></el-table-column>
      <el-table-column prop="age"
                       align="center"
                       header-align="center"
                       label="您的年龄"></el-table-column>
      <el-table-column prop="job"
                       align="center"
                       header-align="center"
                       label="您的职业"></el-table-column>
      <el-table-column prop="r5_info_from"
                       align="center"
                       header-align="center"
                       label="您是从何种渠道得知佳能EOS R5新品上市信息？"></el-table-column>
      <el-table-column prop="buy_r5"
                       align="center"
                       header-align="center"
                       label="您是否准备/已经购买EOS R5"></el-table-column>
      <el-table-column prop="buy_model"
                       align="center"
                       header-align="center"
                       label="您准备/已经购买的相机型号"></el-table-column>
      <el-table-column prop="buy_rf"
                       align="center"
                       header-align="center"
                       label="您是否同时购买了RF镜头？"></el-table-column>
      <el-table-column prop="rf_model"
                       align="center"
                       header-align="center"
                       label="如果“是”，您购买的RF镜头型号：（如果否填无）"></el-table-column>
      <el-table-column prop="is_ef"
                       align="center"
                       header-align="center"
                       label="您是否拥有佳能EF镜头"></el-table-column>
      <el-table-column prop="is_rf"
                       align="center"
                       header-align="center"
                       label="您是否拥有佳能RF镜头"></el-table-column>
      <el-table-column prop="subject"
                       align="center"
                       header-align="center"
                       label="您经常拍摄的对象："></el-table-column>
      <el-table-column prop="camera_brand"
                       align="center"
                       header-align="center"
                       label="您之前使用的相机品牌是"></el-table-column>
      <el-table-column prop="camera_model"
                       align="center"
                       header-align="center"
                       label="您之前使用的相机类型"></el-table-column>
      <el-table-column prop="is_fullframe"
                       align="center"
                       header-align="center"
                       label="您之前的相机是全画幅吗"></el-table-column>
      <el-table-column prop="about_eosr5"
                       align="center"
                       header-align="center"
                       label="您决定购买EOSR5的要素有哪些？请选择最重要的3项"></el-table-column>
      <el-table-column prop="experience_r5"
                       align="center"
                       header-align="center"
                       label="您是否需要EOSR5样机体验？"></el-table-column>
      <el-table-column prop="hobby"
                       align="center"
                       header-align="center"
                       label="请问您的兴趣爱好是？"></el-table-column>
      <el-table-column prop="like_media"
                       align="center"
                       header-align="center"
                       label="请问您最爱的娱乐媒体是？"></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="profession"
                       label="行业"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="business"
                       label="商家"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="store"
                       label="店铺"
                       min-width="110px"
                       show-overflow-tooltip></el-table-column>
    </el-table>
    <el-card>
      <el-row class="pagation-row">
        <el-pagination background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page.sync="queryPrdlists.pagenum"
                       :page-size="queryPrdlists.pagesize"
                       :page-sizes="[10, 20, 50, 100]"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total"></el-pagination>
      </el-row>
    </el-card>
    <export-dialog ref="refExportDialog"
                   @submit="exportSubmit" />
    <import-dialog @submit="handleFile"
                   ref="refImportDialog" />
  </div>
</template>

<script>
import SearchMixin from '@/common/mixins/search-mixin'
import ActionLine from '@/common/mixins/action-line'
import { dealReturn } from '@/common/js/index.js'
import * as Desc from './desc'
export default {
  mixins: [ActionLine, SearchMixin],
  data() {
    return {
      form: {},
      loading: false,
      tableData: [],
      Desc,
    }
  },
  created() {
    // this.getTableData();
  },
  methods: {
    // async getTableData() {
    //   this.loading = true;
    //   let { data, err } = await this.axiosApi(
    //     Desc.list_api,
    //     this.queryPrdlists
    //   );
    //   // console.log("data", data);
    //   this.loading = false;
    //   this.tableData = data.data.data.data;
    //   this.total = parseInt(data.data.data.total);
    //   dealReturn(data, err);
    // },
  },
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/base/memberquesr5/index.vue